import request from '@/libs/request'

//溯源记录 列表
export function traceabilityLogListApi (data) {
  return request({
    url: `plant/traceabilityLog`,
    method: 'get',
    params: data
  })
}

//溯源记录 详情
export function traceabilityLogInfoApi (id) {
  return request({
    url: `plant/traceabilityLog/` + id,
    method: 'get'
  })
}

